import React from 'react';

import classnames from 'classnames';

import { SECTION_BRUSH, SECTION_FALLBACK_ICONS, SECTION_ICONS } from '../../utils/cosmetics';

import './styles.scss';

const HEADER_HEIGHT = 43;

export default function SectionIcon({ section, label, height = HEADER_HEIGHT }) {
  const icon = SECTION_ICONS[section];
  const title = label?.toUpperCase();

  if (icon) {
    const scale = height / HEADER_HEIGHT;

    return (
      <span
        className={classnames('section-icon', `section-icon--${section}`)}
        style={{
          '--section-icon-height': `${height}px`,
          '--section-icon-scale': scale,
        }}
      >
        <span className="section-icon__copy">
          <span className="section-icon__label">{title}</span>
          <img
            className="section-icon__brush"
            src={SECTION_BRUSH}
            alt=""
            aria-hidden
            draggable={false}
          />
        </span>
        <img
          className="section-icon__glyph-img"
          src={icon.src}
          alt=""
          aria-hidden
          draggable={false}
        />
      </span>
    );
  }

  return (
    <span
      className="section-icon section-icon--fallback"
      style={{ '--section-icon-height': `${height}px` }}
    >
      <span className="section-icon__copy">
        <span className="section-icon__label">{title}</span>
        <img
          className="section-icon__brush"
          src={SECTION_BRUSH}
          alt=""
          aria-hidden
          draggable={false}
        />
      </span>
      <span className="section-icon__glyph" aria-hidden>
        {SECTION_FALLBACK_ICONS[section] || '📦'}
      </span>
    </span>
  );
}
